var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "assessment_wrap", style: "height:" + _vm.height },
    [
      _c("div", { staticClass: "assessment_cont" }, [
        _c(
          "div",
          { staticClass: "top_title" },
          [
            _c("h3", [_vm._v("设置考试标准")]),
            _vm._v(" "),
            _c(
              "el-button",
              { attrs: { type: "primary" }, on: { click: _vm.saveAssessment } },
              [_vm._v("保存")]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("ul", [
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1),
          _vm._v(" "),
          _c("li", { staticClass: "third" }, [
            _c("span", { staticClass: "title_label" }, [_vm._v("权重设置")]),
            _vm._v(" "),
            _c("div", { staticClass: "ipt" }, [
              _c("div", { staticClass: "ipt-items" }, [
                _c(
                  "div",
                  { staticClass: "ipt-item" },
                  [
                    _c("span", [_vm._v("课件学习")]),
                    _c("i"),
                    _vm._v(" "),
                    _c("el-input", {
                      model: {
                        value: _vm.courseware,
                        callback: function($$v) {
                          _vm.courseware = $$v
                        },
                        expression: "courseware"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", [_vm._v("%")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ipt-items" }, [
                _c(
                  "div",
                  { staticClass: "ipt-item" },
                  [
                    _c("span", [_vm._v("单元测验")]),
                    _c("i"),
                    _vm._v(" "),
                    _c("el-input", {
                      model: {
                        value: _vm.unitTest,
                        callback: function($$v) {
                          _vm.unitTest = $$v
                        },
                        expression: "unitTest"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", [_vm._v("%")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ipt-items" }, [
                _c(
                  "div",
                  { staticClass: "ipt-item" },
                  [
                    _c("span", [_vm._v("课程考试")]),
                    _c("i"),
                    _vm._v(" "),
                    _c("el-input", {
                      model: {
                        value: _vm.curriculum,
                        callback: function($$v) {
                          _vm.curriculum = $$v
                        },
                        expression: "curriculum"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", [_vm._v("%")])
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "ipt-items" }, [
                _c(
                  "div",
                  { staticClass: "ipt-item" },
                  [
                    _c("span", [_vm._v("考勤签到")]),
                    _c("i"),
                    _vm._v(" "),
                    _c("el-input", {
                      model: {
                        value: _vm.signIn,
                        callback: function($$v) {
                          _vm.signIn = $$v
                        },
                        expression: "signIn"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("span", [_vm._v("%")])
              ])
            ])
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("注：各考核项权重之和为100%")])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("span", { staticClass: "title_label" }, [_vm._v("课程满分")]),
      _vm._v(" "),
      _c("span", [_vm._v("100分")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("li", [
      _c("span", { staticClass: "title_label" }, [_vm._v("学生成绩")]),
      _vm._v(" "),
      _c("span", [
        _vm._v(
          "=（完成课件任务数/课件总任务数）*100 * 课件学习权重 + 单元测验平均分 * 单元测验权重 + 课程考试得分 * 课程考试权重 + 出勤率 * 100 * 考勤签到权重"
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9331e30a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9331e30a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/TeachClass/components/courseAssessment.vue
// module id = null
// module chunks = 